import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { UsersComp } from './users';
import { GetUserList } from '../../models/user';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation } from 'react-router-dom';
import { GetProfileList } from '../../models/profile';


export const Users = () => {
    const userData = useUserStore;
    const [getUsersList, setGetUsersList] = useState(false);
    const [getProfileList, setGetProfileList] = useState(true);
    const [usersList, setUsersList] = useState([]);
    const [profileList, setProfileList] = useState([]);
    const [searchObj, setSearchObj] = useState({});
    const [alertBox, setAlertBox] = useState(false);
    const [showPagination, setShowPagination] = useState(false);
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate();


    const state = {
        getUsersList: getUsersList,
        usersList: usersList,
        loginUserProfile: userData.getState().profile,
        searchObj: searchObj,
        profileList: profileList,
        totalRecords: totalRecords,
        perSet: perSet,
        setNo: setNo,
    }



    useEffect(() => {
        setSearchObj({
            'set_no': setNo,
            'per_set': perSet
        })
        setGetUsersList(true);
    }, []);

    const HandleChangePage = (event, page) => {
        let set_no = setNo;
        if (event.currentTarget.title == 'Go to next page') {
            set_no = set_no + 1;
        }
        else {
            set_no = set_no - 1;
        }
        setSetNo(set_no);
        setSearchObj((prev) => ({ ...prev, ['set_no']: set_no }));
        setGetUsersList(true);
    };

    const HandleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        console.log(event.target.value);
        setPerSet(value);
        setSetNo(1);
        setSearchObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setSearchObj((prev) => ({ ...prev, ['per_set']: value }));
        setGetUsersList(true);

    };

    const ResetPagination = () => {
        setSetNo(1);
        setPerSet(10);
        setSearchObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setSearchObj((prev) => ({ ...prev, ['per_set']: 10 }));
    }


    const HandleInputs = (e, name) => {
        let value = e.target.value;

        setSearchObj((prev) => ({ ...prev, [name]: value }));


        if (name === 'ddlSearchUserType') {
            ResetPagination();
            setGetUsersList(true);
        }

    }

    const HandleCloseAlert = (type) => {
        if (type == 'No') {
            setAlertBox(false);
        }
        else {

            // setDeleteUser(true);
            //  setAlertBox(false)
        }
    }

    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfileList(profileListData);
        }
        else {
            setProfileList([]);
        }
        setGetProfileList(false);
    }


    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUsersList(usersListData);
            setTotalRecords(res.data.userlistresponse.metarow.totalRecordsInDb);

        }
        else {
            setUsersList([]);
            setTotalRecords(0);
        }
        setGetUsersList(false);
    }



    const NavigateTo = (route) => {
        navigate('/' + route, { state: { usersList: usersList } });
    }

    const DeleteUser = (user_name) => {
        // setAlertBox(true)
        // setUserName(user_name);
    }



    const GetUserDetails = (user_id) => {
        NavigateTo('user/' + user_id);
    }


    const SearchUserList = (type) => {
        if (type === 'direct') {
            setSearchObj((prev) => ({ ...prev, ['ddlSearchUserType']: '' }));
        }
        else {
            setSearchObj((prev) => ({ ...prev, ['txtUserSearchName']: '' }));
            setSearchObj((prev) => ({ ...prev, ['ddlSearchUserType']: '' }));
        }

        ResetPagination();

        setGetUsersList(true);

    }


    return (
        <Box>
            <UsersComp usersList={usersList} mystate={state} HandleInputs={HandleInputs} SearchUserList={SearchUserList} HandleCloseAlert={HandleCloseAlert} NavigateTo={NavigateTo} DeleteUser={DeleteUser} GetUserDetails={GetUserDetails} HandleChangePage={HandleChangePage} HandleChangeRowsPerPage={HandleChangeRowsPerPage} />
            {((getProfileList === true) ? GetProfileList(pnkstore, {}, userData.getState().token, HandleGetProfilesListSuccessResponse) : '')}
            {((getUsersList === true) ? GetUserList(pnkstore, searchObj, userData.getState().token, HandleGetUsersListSuccessResponse) : '')}
        </Box>
    )
}